import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ComponentDefinition} from '@formbird/types';
import {FormbirdInjectorService} from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import {ChangedDocumentService} from 'formbird-services';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {MatTooltip} from '@angular/material/tooltip';
import {MatFormField} from '@angular/material/form-field';


interface NoteBoxComponentDefinition extends ComponentDefinition {
  noteBoxRows?: number;
  limitCharacterCount?: number;
  visualCharacterCount?: boolean;
  displayCharacterCount?: boolean;
}

@Component({
  templateUrl: './note-box.component.html',
  styleUrls: ['./note-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class NoteBoxComponent extends AbstractComponent<NoteBoxComponentDefinition> implements OnInit, AfterViewInit {

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);
    this.notificationService = this.formbirdInjectorService.get(
      'NotificationService'
    );
  }

  @ViewChild('taLimitCharacterCount', {static: true}) taLimitCharacterCount: ElementRef;
  @ViewChild('taNoLimitCharacterCount', {static: true}) taNoLimitCharacterCount: ElementRef;

  notificationService: any;

  visible = true;
  noteBoxRows = 3;
  disableSave = false;
  limitCharacterCount = 0;
  visualCharacterCount = false;
  charactersCountDisplay: string;
  progressPercentageValue: any;

  docData;

  componentElement: HTMLElement;
  startX;
  startY;
  startWidth;
  startHeight;
  doDragHandler: any;
  stopDragHandler: any;

  ngOnInit() {

    this.shouldNotifyCompInitializedInSuper = false;

    super.ngOnInit();

    if (!(typeof this.componentDefinition.visible === 'undefined' || this.componentDefinition.visible === null)) {
      this.visible = this.componentDefinition.visible;
    }

    if (!(typeof this.componentDefinition.noteBoxRows === 'undefined' || this.componentDefinition.noteBoxRows === null)) {
      this.noteBoxRows = this.componentDefinition.noteBoxRows;
    }

    if (!(typeof this.componentDefinition.disableSave === 'undefined' || this.componentDefinition.disableSave === null)) {
      this.disableSave = this.componentDefinition.disableSave;
    }

    if (!(typeof this.componentDefinition.limitCharacterCount === 'undefined' || this.componentDefinition.limitCharacterCount === null)) {
      this.limitCharacterCount = this.componentDefinition.limitCharacterCount;
    }

    if (!(typeof this.componentDefinition.visualCharacterCount === 'undefined' || this.componentDefinition.visualCharacterCount === null)) {
      this.visualCharacterCount = this.componentDefinition.visualCharacterCount;
    }

    if (this.fieldValue) {
      const jsonValue = JSON.stringify(this.fieldValue);
      this.docData = JSON.parse(jsonValue);
      if (this.limitCharacterCount > 0) {
        this.charactersCountDisplay = this.docData.length + '/' + this.limitCharacterCount;
        this.progressPercentageValue = (this.docData.length / this.limitCharacterCount) * 100;
      } else {
        this.charactersCountDisplay = this.docData.length;
        this.progressPercentageValue = 100;
      }
      if (this.taNoLimitCharacterCount) {
        this.taNoLimitCharacterCount.nativeElement.value = this.docData;
      }
      if (this.taLimitCharacterCount) {
        this.taLimitCharacterCount.nativeElement.value = this.docData;
      }
    } else {
      if (this.limitCharacterCount > 0) {
        this.charactersCountDisplay = 0 + '/' + this.limitCharacterCount;
        this.progressPercentageValue = 0;
      } else {
        this.charactersCountDisplay = '0';
        this.progressPercentageValue = 100;
      }
    }

  }// end ngOnInit

  ngAfterViewInit(): void {
    this.updateDataSetReplicatedValue();
  }

  onFieldValueChanged(fieldValue) {
    this.fnNoteBoxChanged(undefined, fieldValue);
    super.onFieldValueChanged(fieldValue);
  }

  protected onControlValueChanged(value) {
    this.updateDataSetReplicatedValue();
    super.onControlValueChanged(value);
  }

  initDrag(e) {
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.startWidth = parseInt(document.defaultView.getComputedStyle(this.componentElement).width, 10);
    this.startHeight = parseInt(document.defaultView.getComputedStyle(this.componentElement).height, 10);

    this.doDragHandler = this.doDrag.bind(this);
    this.stopDragHandler = this.stopDrag.bind(this);
    e.target.addEventListener('mousemove', this.doDragHandler, true);
    e.target.addEventListener('mouseup', this.stopDragHandler, true);
  }

  doDrag(e) {
    this.componentElement.style.width = (this.startWidth + e.clientX - this.startX) + 'px';
    this.componentElement.style.height = (this.startHeight + e.clientY - this.startY) + 'px';
  }

  stopDrag(e) {
    e.target.addEventListener('mousemove', this.doDragHandler, true);
    e.target.addEventListener('mouseup', this.stopDragHandler, true);
  }

  fnNoteBoxChanged($event, fieldValue?) {
    let val = '';
    if ($event) {
      val = $event?.target?.value;
    }
    if (!(typeof fieldValue === 'undefined' || fieldValue === null)) {
      val = fieldValue;
    }

    if (this.limitCharacterCount > 0) {
      this.charactersCountDisplay = val?.length + '/' + this.limitCharacterCount;
      this.progressPercentageValue = (val?.length / this.limitCharacterCount) * 100;
    } else {
      this.charactersCountDisplay = val?.length + '';
      this.progressPercentageValue = 100;
    }
    this.updateDataSetReplicatedValue();
  }

  updateDataSetReplicatedValue() {
    if (this.noteBoxRows === -1) {
      setTimeout(() => {
        const noteBoxElement: any = document.querySelector('.divNoteBoxResizeContainer' + this.fieldName + this.key + ' textarea');
        if (noteBoxElement) {
          noteBoxElement.parentNode.dataset.replicatedValue = noteBoxElement.value;
          this.detectChanges();
        }
      });
    }
  }

  initializeExpandable() {
    console.log('%c initializeExpandable', 'color:blue');
    this.componentElement = document.getElementById(this.fieldName);
    if (this.disabled) {
      this.componentElement.style['background-color'] = '#f1f1f1';
      this.componentElement.style.cursor = 'not-allowed';
    } else {
      this.componentElement.style['background-color'] = 'white';
      this.componentElement.style.cursor = '';
    }
    this.componentElement.addEventListener('mousedown', this.initDrag.bind(this), true);
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
